<template>
  <div>
    <h2>{{ $t('event.list.mainTitle') }}</h2>

    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <dx-data-grid
      id="gridContainerEventlist"
      :data-source="items"
      :allow-column-reordering="false"
      :allow-column-resizing="true"
      :column-min-width="50"
      columnResizingMode="widget"
      :show-borders="true"
      :showColumnLines="true"
      :showRowLines="true"
      key-expr="field_001"
      :no-data-text="$t('general.noEntries')"
      :column-auto-width="true"
      :word-wrap-enabled="true"
      :hover-state-enabled="true"
      :focused-row-enabled="true"
      @row-click="onRowSelected"
    >

      <dx-scrolling mode="virtual"/>

      <dx-search-panel
        :visible="true"
        :width="320"
        placeholder="Search..."
      />

      <dx-column
        data-field="field_001"
        :caption="$t('event.list.id')"
        :fixed="true"
      />
      <dx-column
        data-field="anzeigedatum"
        :caption="$t('event.list.displaydate')"
      />
      <dx-column
        data-field="sortierdatum"
        :caption="$t('event.list.date')"
        :calculate-cell-value="dateCellValue"
        :allow-filtering="true"
      />
      <dx-column
        data-field="eventname"
        :caption="$t('event.list.eventname')"
        :calculate-cell-value="titelCellValue"
        :allow-filtering="true"
      />
      <dx-summary>
        <dx-total-item
          column="field_001"
          summary-type="count"
        />
      </dx-summary>
    </dx-data-grid>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSearchPanel,
    DxSummary,
    DxTotalItem
  } from 'devextreme-vue/data-grid'
  import moment from 'moment'

  export default {
    components: {
      DxDataGrid,
      DxColumn,
      DxScrolling,
      DxSearchPanel,
      DxSummary,
      DxTotalItem
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        isBusy: false
      }
    },
    created () {
      this.onGetEvents()
      this.getBasicValues('basicValues/GET_FACULTY_UNIVERSITY_TYPES', this.facultyUniversityTypes)
      this.getBasicValues('basicValues/GET_UNIVERSITY_TYPES', this.universityTypes)
      this.getBasicValues('basicValues/GET_BRANCHE_TYPES', this.brancheTypes)
      this.getBasicValues('basicValues/GET_STARTUPHASE_TYPES', this.startupPhaseTypes)
      this.getBasicValues('basicValues/GET_COUNTRY_TYPES', this.countryTypes)
      this.getBasicValues('basicValues/GET_CASEQUALITY_TYPES', this.casequalityTypes)
      this.getBasicValues('basicValues/GET_AFFIRMATION_TYPES', this.affirmationTypes)
      this.getBasicValues('basicValues/GET_RECHTSFORM_TYPES', this.rechtsformTypes)
      this.getBasicValues('basicValues/GET_LANGUAGES_TYPES', this.languagesTypes)
      this.getBasicValues('basicValues/GET_EDUCATION_TYPES', this.educationTypes)
      this.getBasicValues('basicValues/GET_CANTON_TYPES', this.cantonTypes)
      this.getBasicValues('basicValues/GET_SALUTATION_TYPES', this.salutationTypes)
      this.getBasicValues('basicValues/GET_PRIOVLAB_TYPES', this.priovlabTypes)
      this.getBasicValues('basicValues/GET_PRIOVLABXMAS_TYPES', this.priovlabxmasTypes)
      this.getBasicValues('basicValues/GET_PROFILCATEGORY_TYPES', this.profilcategoryTypes)
      this.getBasicValues('basicValues/GET_VKCASESTATUS_TYPES', this.vkCaseStatusTypes)
      this.getBasicValues('basicValues/GET_EVENT_SIGNUP_FUNKTION', this.eventSignupFunctions)
      this.getBasicValues('basicValues/GET_INVESTMENT_STAGES', this.investmentStages)
      // this.registerUserManually()
    },
    methods: {
      /* async registerUserManually () {
        try {
          const { errors } = await this.$store.dispatch('user/REGISTER')
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      }, */
      async onGetEvents () {
        this.hasError = false
        this.isBusy = true
        this.$Progress.start()

        try {
          const { errors } = await this.$store.dispatch('event/GET_EVENTS')
          if (errors) throw errors
          this.isBusy = false
          this.$Progress.finish()
        } catch (err) {
          this.isBusy = false
          this.hasError = true
          this.$Progress.fail()
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      async getBasicValues (storePath, storeValue) {
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
          } catch (err) {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            setTimeout(() => {
              this.hasError = false
            }, 5000)
          }
        }
      },
      dateCellValue (rowData) {
        return moment(rowData.sortierdatum).format('DD.MM.YYYY')
      },
      titelCellValue (rowData) {
        const titel = rowData.course_no !== null ? rowData.course_no + ' - ' + rowData.eventlisttitleEN : rowData.eventlisttitleEN
        return titel
      },
      async onRowSelected (e) {
        const field_001 = e.data.field_001 /* eslint-disable-line */

        await this.$router.push({
          name: 'seminar-detail',
          params: { id: field_001 }
        })
      }
    },
    computed: {
      ...mapGetters({
        items: 'event/EVENTS',
        facultyUniversityTypes: 'basicValues/FACULTY_UNIVERSITY_TYPES',
        universityTypes: 'basicValues/UNIVERSITY_TYPES',
        brancheTypes: 'basicValues/BRANCHE_TYPES',
        startupPhaseTypes: 'basicValues/STARTUPHASE_TYPES',
        countryTypes: 'basicValues/COUNTRY_TYPES',
        casequalityTypes: 'basicValues/CASEQUALITY_TYPES',
        affirmationTypes: 'basicValues/AFFIRMATION_TYPES',
        rechtsformTypes: 'basicValues/RECHTSFORM_TYPES',
        languagesTypes: 'basicValues/LANGUAGES_TYPES',
        educationTypes: 'basicValues/EDUCATION_TYPES',
        cantonTypes: 'basicValues/CANTON_TYPES',
        salutationTypes: 'basicValues/SALUTATION_TYPES',
        priovlabTypes: 'basicValues/PRIOVLAB_TYPES',
        priovlabxmasTypes: 'basicValues/PRIOVLABXMAS_TYPES',
        profilcategoryTypes: 'basicValues/PROFILCATEGORY_TYPES',
        vkCaseStatusTypes: 'basicValues/VKCASESTATUS_TYPES',
        eventSignupFunctions: 'basicValues/EVENT_SIGNUP_FUNCTIONS',
        investmentStages: 'basicValues/INVESTMENT_STAGES'
      })
    }
  }
</script>
<style>
#gridContainerEventlist {
    height: 78vh;
    margin-bottom: 0;
}

.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row) > td:not(.dx-focused) {
    cursor: pointer;
}
</style>
